<template>
  <div class="CustomerOrderListViewContainer">
    <InfiniteLoadingList :query-id="2">
      <template v-slot="data">
        <SaleOrderCard :data="data.data"/>
      </template>
    </InfiniteLoadingList>
  </div>
</template>

<script>
import SaleOrderCard from "@/components/sale/SaleOrderCard";
import InfiniteLoadingList from "@/components/InfiniteLoadingList";
import api from "@/api";
import {Dialog, } from "@nutui/nutui";

export default {
  name: "CustomerOrderListView",
  components: {InfiniteLoadingList, SaleOrderCard},

  methods: {
    init() {
      api.getUserInfo()
          .then(ret => {
            if (ret.phone) {
              return
            }
            Dialog({
              title: '您未绑定手机号',
              content: '为了更好的服务推荐立即绑定手机号',
              cancelText:'下次吧',
              okText:'好的',
              onCancel: () => {

              },
              onOk: () => {
                this.$router.push('/fill/user/info');
              }
            });
          })
    }
  },
  mounted() {
    this.init()
    document.title = '订单列表'
  }
}
</script>

<style lang="scss" scoped>
.CustomerOrderListViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;
}
</style>